import React , {useEffect, useRef, useState} from 'react'
import DataTable,  { createTheme  } from 'react-data-table-component';
import Axios from 'axios';
import { useContext } from 'react'
import AuthContext from './AuthContext';
import Modals from './Modals';
import Modals_Load from './Modals_Load';

import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

import { useHistory } from "react-router-dom";

import ReactToPrint from "react-to-print";
import "./istyles.css";
import JsBarcode from 'jsbarcode';  // Import JsBarcode
import { QRCodeSVG } from 'qrcode.react'; // Import QRCodeSVG instead of default

import { format, parseISO, isAfter } from 'date-fns';

import FrmQEditProfile from './FrmQEditProfile'


/*
  //1234567890121  //gnuserid or cardid
  if (loading) {
   return <h1>Loading...</h1>;
  }

  return (
    <ul className='list-group mb-4'>
      {posts.map(post => (
        <li key={post.id} className='list-group-item'>
          {post.title}
        </li>
      ))}
    </ul>
  );

*/

const formatID_Number = (id) => {
  if (!id || id.length !== 13) return id; // ตรวจสอบว่าค่าที่รับมาเป็น 13 หลักหรือไม่
  return `${id[0]} ${id.slice(1, 5)} ${id.slice(5, 10)} ${id.slice(10, 12)} ${id[12]}`;
};

const formatPhoneNumber = (phone) => {
  if (!phone || phone.length !== 10) return phone; // ตรวจสอบว่าความยาวถูกต้อง
  return `${phone.slice(0, 3)}-${phone.slice(3, 6)}-${phone.slice(6, 10)}`;
};

const FullInvoice = React.forwardRef(({invoice}, ref) => { 
  
    const barcodeRef_taxid = useRef(null);  // barcode taxid
    const barcodeRef_ref11 = useRef(null); // barcode paymentcode + id_number + mod
    const barcodeRef_ref2 = useRef(null);  // barcode cost
    

    useEffect(() => {
      if (barcodeRef_taxid.current) {
        JsBarcode(barcodeRef_taxid.current, invoice.taxid, {
          format: 'CODE128',  // Use CODE128 format
          displayValue: true,  // Show the text below the barcode
          lineColor: '#000000',  // Barcode color
          width: 1,  // Width of barcode lines
          height: 41,  // Height of the barcode
          fontSize: 14,  // Font size of the barcode text
          margin: 10,  // Margin around the barcode        
        });
      }
      if (barcodeRef_ref11.current) {
        JsBarcode(barcodeRef_ref11.current, invoice.ref11, {
          format: 'CODE128',  // Use CODE128 format
          displayValue: true,  // Show the text below the barcode
          lineColor: '#000000',  // Barcode color
          width: 1,  // Width of barcode lines
          height: 41,  // Height of the barcode
          fontSize: 14,  // Font size of the barcode text
          margin: 10,  // Margin around the barcode        
        });
      }
      if (barcodeRef_ref2.current) {
        JsBarcode(barcodeRef_ref2.current, invoice.ref2, {
          format: 'CODE128',  // Use CODE128 format
          displayValue: true,  // Show the text below the barcode
          lineColor: '#000000',  // Barcode color
          width: 1,  // Width of barcode lines
          height: 41,  // Height of the barcode
          fontSize: 14,  // Font size of the barcode text
          margin: 10,  // Margin around the barcode        
        });
      }
  
    }, [invoice.ref11]);
    
    
  return (
    <div ref={ref} style={{ marginLeft: '20px' }}>   
    <br></br>
     <table border="0">
      <tr>
        <td><img height="99" src="./New_CU-Logo.jpg" width="85"/></td>
        <td style={{"height": "81px", "width": "382px"}}>คณะพาณิชยศาสตร์และการบัญชี จุฬาลงกรณ์มหาวิทยาลัย หลักสูตรบริหารธุรกิจมหาบัณฑิต<br></br>
            <span style={{"font-size":"20pt","font-weight":"bold","height":"16px","width":"200px"}}>ใบแจ้งชำระเงินค่าสมัครสอบ</span></td>   
        <td>&nbsp;&nbsp;&nbsp;</td>
        <td>&nbsp;&nbsp;&nbsp;</td>
        <td>&nbsp;&nbsp;&nbsp;</td>
        <td>&nbsp;&nbsp;&nbsp;</td>

        <td></td>     
        <td valign="middle" nowrap="">
									<div>Tax ID:
                  {/* <font face="Tahoma">Tax ID:</font>                  */}
          <svg ref={barcodeRef_taxid}></svg> {/* SVG for rendering the barcode */}   
        </div></td>
      
      </tr>
     </table>

     <table border="0" width="90%">
      <tr>
        <td nowrap="" style={{"width": "178px"}}><strong>รหัสประจำตัวประชาชน</strong></td>
        <td style={{"width":"199px"}}><span style={{"width":"96px"}}>{formatID_Number(invoice.ID_Number)}</span></td>        
       
        {/* <td valign="middle" nowrap="" align="right" rowspan="4" style={{"WIDTH": "63px", "text-align": "right"}}>
						<p align="right"><font face="Tahoma">Ref 1: </font>
						</p>
				</td> */}
        <td></td>
        <td valign="middle" nowrap="" align="right" rowspan="4">
						<div>Ref 1:
            <svg ref={barcodeRef_ref11}></svg> {/* SVG for rendering the barcode */}   
            </div></td>        
     

      </tr>
      <tr>
          <td style={{"width": "178px"}}><strong>ชื่อผู้สมัคร</strong></td>
          <td style={{"width":"199px"}}><span style={{"width":"168px"}}>{invoice.fullname}</span></td>        
      </tr>
      

      <tr>
					<td nowrap="" style={{"width": "178px"}}><strong>หมายเลขโทรศัพท์มือถือ</strong></td>
					<td style={{"width":"199px"}}><span>{formatPhoneNumber(invoice.mobilephone)}</span></td>
			</tr>
     
      <tr>
        <td nowrap="" style={{"width": "178px"}}><strong>หลักสูตร</strong></td>
        <td style={{"width":"199px"}}><span style={{"width":"168px"}}>{invoice.course}</span></td>
      </tr>
      
      <tr>
      <td nowrap="" style={{"width": "178px"}}><strong>วันที่ออกใบรับชำระเงิน</strong></td>
      <td style={{"width":"199px"}}><span style={{"width":"162px"}}>{invoice.startdate}</span></td>
      

      {/* <td valign="middle" nowrap="" align="right" rowspan="4" style={{"WIDTH": "63px"}}>
						<p align="right"><font face="Tahoma"> Ref 2:</font></p>
					</td> */}
      <td></td>
      <td valign="middle" nowrap="" align="right" rowspan="4">
			  <div>Ref 2:
          <svg ref={barcodeRef_ref2}></svg> {/* SVG for rendering the barcode */}   
        </div></td>	

      </tr>

      <tr>
					<td style={{"width": "178px"}}><strong>ค่าสมัคร </strong>
					</td>
					<td style={{"width":"199px"}}><span style={{"width":"115px"}}>{invoice.cost.toLocaleString()}.00 บาท</span></td>
				</tr>
				<tr>
					<td style={{"width": "190px"}}><strong>วันครบกำหนดรับชำระเงิน</strong></td>
					{/* <td style={{"width":"199px"}}><span>{invoice.enddate}</span></td> */}
          <td style={{"width":"199px", fontSize: "18px"}}><span>{invoice.enddate}</span></td>
          {/* <td align="left"><font face="Tahoma"><span style={{"width":"320px", fontSize: "18px"}}><b>{invoice.testid}</b></span></font></td> */}
          
				</tr>
				<tr>
					<td style={{"width": "178px"}}></td>
					<td style={{"width":"199px"}}></td>
				</tr>

     </table>

     
     <div style={{"width": "688px"}}>     
     {/* <u><b>เพื่อประโยชน์สำหรับผู้สมัครสอบ โปรดอ่าน ! :</b></u><br></br> */}
		    {/* ------------------------------------------------------------------------------------------------<br></br> */}
        <hr></hr>
        <b>การชำระเงิน</b> :<br></br>
        : นำใบแจ้งชำระเงิน (payment slip) นี้ไปชำระค่าสมัครสอบได้ที่ counter service หรือ
        7-11 ทุกสาขา ภายในช่วงเวลาที่เปิดรับสมัครเท่านั้น<u> เพื่อประโยชน์ของผู้สมัครเอง เมื่อชำระเงินแล้วให้ตรวจสอบความถูกต้องของข้อมูลหลังการชำระเงิน</u>
     โดยดูรายละเอียดจากใบรับชำระที่ได้จากทาง counterservice ดังนี้<br></br>
- ใบรับฝากชำระ ระบุ<b>"MBA จุฬาฯ"</b><br></br>
- ยอดรับชำระตรงตามยอดจำนวนค่าสมัครในใบแจ้งชำระเงิน<br></br>
- ยอดการชำระ 1 ใบ ต่อการชำระเงิน 1 รายการเท่านั้น ห้ามชำระรวมกัน <br></br>
-ใบรับฝากชำระเงินนี้ใช้สำหรับชำระเงินสำหรับการสมัครสอบ cubest ในรอบสอบตามที่ระบุด้านบนเท่านั้น การใช้ใบรับฝากชำระเงินของการสอบรอบอื่น ไม่ถือว่าเป็นการชำระเงิน<br></br>
<b>(ไม่รับชำระผ่านทางระบบชำระเงินอื่นๆ)</b><br></br>
หากพบว่ามีความผิดพลาดตามที่ระบุข้างต้น ขอให้แจ้งแก้ไขกับทาง Counter Service ทันที และทำการภายในกำหนดรับสมัครเท่านั้น หากพ้นกำหนดการรับสมัครแล้วขอสงวนสิทธิ์ไม่รับผิดชอบ และไม่เปิดให้ชำระเงินใหม่<br></br>
*หากผู้สมัครชำระเงินแล้ว จะไม่มีการคืนเงินค่าสมัครสอบไม่ว่าในกรณีใดๆ ก็ตามยกเว้นในกรณีที่มีความเปลี่ยนแปลงจากทางจุฬาลงกรณ์มหาวิทยาลัย<br></br>

*ขอสงวนสิทธิ์ในการตัดสิทธิ์สอบ และไม่คืนเงินค่าสมัคร หากผู้สมัครสอบชำระเงินหลังจากช่วงเวลาที่กำหนด หรือชำระเงินผิดช่องทางการชำระไม่ว่ากรณีใดๆ ทั้งสิ้น <br></br>
*ขอสงวนสิทธิในการไม่คืนเงินค่าสมัครที่เป็นส่วนเกินจากยอดค่าสมัครที่ระบุ ไม่ว่ากรณีใดๆ ทั้งสิ้น<br></br>

   <b>การตรวจสอบสถานะการชำระเงิน</b> :<br></br>
        : ผู้สมัครสามารถตรวจสอบสถานะการชำระเงินจากเว็บรับสมัครสอบ หลังจากที่ชำระเงินแล้วประมาณ 3-5วัน ทางระบบรับสมัครสอบ CUBEST <br></br>
   <b>การตรวจสอบเลขที่นั่งสอบและห้องสอบ</b> :<br></br>
        : สามารถตรวจสอบเลขที่นั่งสอบ และห้องสอบ ได้จากเมนู "ประวัติการสมัคร" ตามวันเวลาที่ประกาศผังสอบไว้<br></br>
        : ผู้สมัครสามารถตรวจสอบเลขที่นั่งสอบและผังห้องสอบอีกครั้ง รวมถึงระเบียบข้อปฏิบัติในการสอบได้จาก หน้าประกาศเลขที่นั่งสอบในเว็บไซต์ <a href="https://mba.cbs.chula.ac.th">https://mba.cbs.chula.ac.th</a><br></br>
        : หลักสูตรจะไม่มีการส่งบัตรประจำตัวสอบไปให้ ผู้สอบจะต้องใช้ "บัตรประจำตัวประชาชน" แสดงต่อเจ้าหน้าที่ในห้องสอบ<br></br>
<hr></hr>
		<b>ทางศูนย์ทดสอบไม่มีการออกใบเสร็จรับเงินค่าสมัครสอบ ผู้สมัครสามารถใช้ใบรับฝากชำระเงินจาก Counter Service แทนได้</b>

      
    </div>      
    </div>
  );
});

const FullPlaces = React.forwardRef(({invoice}, ref) => {  

 return (
  <div ref={ref} style={{ marginLeft: '20px' }}>   
  <br></br>
  
  <strong>                
        <span style={{ float: "right", marginRight: "15px" }}>{invoice.testid}</span>
  </strong>
  
  <br></br>
  <table  border="0" cellspacing="1" cellpadding="1" style={{"WIDTH": "648px", "HEIGHT": "65px"}}>
							<tr>
								<td rowSpan = "4" style={{"WIDTH": "197px"}}><img height="99" src="./New_CU-Logo.jpg" width="85"/></td>
                                                
                <tr>
                
                <td align="center"><strong>แจ้งสถานที่สอบวิชาความถนัดทางธุรกิจ 
                            (CU-BEST)</strong></td>
                </tr>

                
                <tr>
											<td align="center"><strong>Examination Location 
														Announcement</strong></td>
								</tr>

                <tr>
											<td align="center"><strong>Chulalongkorn 
														University - Bussiness Entrance Scholastic Test</strong>
											</td>
										</tr>

                <tr>
											<td align="center"><strong>ครั้งที่:&nbsp;</strong>
												<span>{invoice.CUBEST}</span></td>
								</tr>
								              
              </tr>
            </table>
            
            <table style={{marginLeft: "10px","WIDTH": "648px", "HEIGHT": "65px"}} cellSpacing="1" cellPadding="1"  align="left" border="0">
            <tr>
								<td align="right" style={{"width": "129px"}}>ชื่อ-นามสกุล:&nbsp;</td>
								<td align="left"><span style={{"width":"320px"}}>{invoice.fullname}</span></td>
						</tr>

            <tr>
								<td align="right" style={{"width": "129px"}}>เวลาสอบ:&nbsp;</td>
								<td align="left">9.00 - 12.00 น.</td>
						</tr>
            
            <tr>
								<td align="right" style={{"width": "129px"}}>วันที่สอบ:&nbsp;</td>
								<td align="left"><span style={{"width":"320px"}}>{invoice.testdate}</span></td>
						</tr>
										<tr>
											<td align="right" style={{"width": "129px"}}>เลขประจำตัวสอบ:&nbsp;</td>
											<td align="left"><span style={{"width":"320px"}}><strong>{invoice.testid}</strong></span></td>
										</tr>
										<tr>
											<td align="right" style={{"width": "129px"}}>สถานที่:&nbsp;</td>
											<td align="left">
													<span id="lblPlace" style={{"width":"320px"}}>{invoice.testplace}</span></td>
										</tr>
										<tr>
											<td align="right" style={{"width": "129px"}}>ตึก:&nbsp;</td>
											<td align="left">
													<span style={{"width":"320px"}}>{invoice.testbuilding}</span></td>
										</tr>
										<tr>
											<td align="right" style={{"width": "129px"}}>ห้อง:&nbsp;</td>
											<td align="left">
													<span style={{"width":"320px"}}>{invoice.testroom}</span></td>
										</tr>
										<tr>
											<td align="right" style={{"width": "129px"}}>ชั้น:&nbsp;</td>
											<td align="left">
												<span style={{"width":"320px"}}>{invoice.testlevel}</span></td>
										</tr>										
            </table>
            
  <div style={{ clear: "both" }}></div> {/* Forces tbl3 to a new line */}

 <table style={{ "marginTop": "20px", "WIDTH": "237px"}} cellSpacing="1" cellPadding="1" border="0">
 <tr><td>
            <u>ระเบียบในการสอบ CU-BEST</u><br></br>
<b>โปรดดูรายละเอียดเกี่ยวกับการเข้าสอบเพิ่มเติมจากเว็บไซด์หลักสูตร MBA: https://mba.cbs.chula.ac.th</b><br></br>
 1. เวลาเริ่มสอบ 09.00 น. - 12.00 น.<br></br>
 2. ผู้ที่มาหลังจาก 09.30 น. จะไม่ได้รับอนุญาตให้เข้าห้องสอบ<br></br>
 3. ผู้เข้าสอบจะต้องนำบัตรประจำตัวประชาชนมาแสดงเพื่อเป็นหลักฐานต่อเจ้าหน้าที่คุมสอบ หากไม่ได้นำมาจะไม่ให้เข้าสอบโดยเด็ดขาด<br></br>
 4. ห้ามใช้เครื่องคำนวณทุกประเภท และปิดเครื่องมือสื่อสารทุกชนิด<br></br>
 5. ต้องแต่งกายสุภาพในการเข้าสอบ<br></br>
 6. ไม่อนุญาตให้นำกระดาษใดๆ เข้าไปยังโต๊ะที่นั่งสอบและไม่อนุญาตให้นำเนื้อหาส่วนใดของข้อสอบออกจากห้องสอบ "เด็ดขาด"<br></br>
 7. หากทุจริตในการสอบจะได้ 0 คะแนน จะถูกตัดสิทธิ์ในการสอบ CU-BEST ตลอดไป<br></br>
<b><u>ตรวจสถานที่สอบและแผนที่</u></b>
<a href="http://mba.cbs.chula.ac.th/wp-content/uploads/%E0%B9%81%E0%B8%9C%E0%B8%99%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%84%E0%B8%93%E0%B8%B0%E0%B8%9A%E0%B8%B1%E0%B8%8D%E0%B8%8A%E0%B8%B52022Nov-1.jpg">[แผนที่คณะพาณิชยศาสตร์และการบัญชี]</a>
<br></br>
<a href="http://mba.cbs.chula.ac.th/wp-content/uploads/mapfaculty_forpost.pdf">[ แผนที่ห้องภายในพื้นที่คณะพาณิชยศาสตร์และการบัญชีอาคารไชยยศสมบัติ และ อาคารอนุสรณ์50ปี ] </a>
<br></br>
{/* <img src="./MBAmapbuilding.png" height="100px" width="100px"/> */}
<div style={{ position: "relative", width: "100px", textAlign: "center" }}>
      <img src="./MBAmapbuilding.png" height="100" width="100"/>
      <div style={{ position: "absolute", bottom: "0", width: "100%", background: "white", fontSize: "12px" }}>
        map
      </div>
</div>

</td>
</tr>
</table>
<br></br>
<table style={{"WIDTH": "648px", "HEIGHT": "65px"}} cellSpacing="1" cellPadding="1" align="left" border="0">
            <tr>
							<td align="left">Master Business Administration</td>
						</tr>
            <tr>
              <td align="left">Faculty of Commerce and</td>
            </tr>
            <tr>
              <td align="left">Accountancy</td>
            </tr>
            <tr>
              <td align="left">Chulalongkorn University
              </td>
            </tr>
            <tr>
              <td align="left">
                Room&nbsp;506, 50th Memorial Bld.
              </td>
            </tr>
            <tr>
              <td align="left">Phayathai Rd. Bangkok 10330</td>
          </tr>
            <tr>
              <td align="left">Thailand</td>
            </tr>
            <tr>
              <td align="left">Tel. (66)-2218-5717 to 9
              </td>
            </tr>
           
            <tr>
              <td align="left">Website:&nbsp;<a href="https://mba.cbs.chula.ac.th">https://mba.cbs.chula.ac.th</a></td>
            </tr>

</table>
  

</div>
);
});


const FrmApplication_th = () => {

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const fullInvoiceRefs = useRef([]);
  const fullPlacesRefs = useRef([]);
    
  const modalsRef = useRef(null);
  const modalsRef_load = useRef(null);
  const history = useHistory();
  
  const {token,settoken} = useContext(AuthContext);

  const [q, setq] = useState("");
  
  const [data,setdata] = useState([]);
  const [data2,setdata2] = useState([]);  
    
  const [searchcolumns,setsearchcolumns] = useState(["ref","test_language"]);
  const [searchcolumns2,setsearchcolumns2] = useState(["CUBEST","test_language"]);
  
  const [isedit,setisedit] = useState("0");

  const [pending, setPending] = useState(true);
  const [pending2, setPending2] = useState(true);

  const {gclang} = useContext(AuthContext);

  const {gnuserid} = useContext(AuthContext);

  const [Qlang,setQlang] = useState({        
    lang:gclang,
    ID_Number:gnuserid    
  });

  const [isprintinvoice, setisprintinvoice] = useState([]);
  const [isprintplace, setisprintplace] = useState([]);

   const [QEdittemplate,setQEdittemplate] = useState({        
      lang:gclang,
      ID_Number:gnuserid,
      CUBEST:'',
      LeadName:'',
      First_Name_Thai:'',
      Last_Name_Thai:'',
      First_Name_Eng:'',
      Last_Name_Eng:'',
      Birth_Date:'',    
      Sex:'',
      ID_Issue_Place:'',
      ID_Expiry_Date:'',    
      Email:'',  
      Address1:'',
      Telephone:'',
      MobilePhone:'',                
      Target_Program:'',
      Target_ProgramArr:[] 
    });

  
  useEffect(() => {
   
    async function fetchData() { 

      modalsRef_load.current.fnshow();  
      const response2 = await Axios.post('/qnewprogram',Qlang,{               
          'withCredentials': false,     
          headers:{
              "x-access-token": token,              
              'Cache-Control': 'no-cache',
              'Pragma': 'no-cache',
              'Expires': '0',        
            }});
      
      modalsRef_load.current.fnclose();            
      let output2 = response2.data; 
      console.log('tid2',output2);      
      setPending(false);                  
      setdata(output2)              
                                
    }

    async function fetchData2() { 
      
      const response3 = await Axios.post('/qapplyprogram',Qlang,{               
          'withCredentials': false,     
          headers:{
              "x-access-token": token,              
              'Cache-Control': 'no-cache',
              'Pragma': 'no-cache',
              'Expires': '0',        
            }});
            
      let output3 = response3.data; 
      console.log('tid3',output3);
      
      setPending2(false);                  
      setdata2(output3);
            
      const invoiceArray = [];
      const placeArray = [];

      for (let x = 0; x < output3.length; x++) {
        if (output3[x].AnnouceTestPlace === "N") {
          invoiceArray.push(true);
          placeArray.push(false);
        } else if (output3[x].AnnouceTestPlace === "Y") {
          invoiceArray.push(false);
          placeArray.push(true);
        }
      }

      setisprintinvoice(invoiceArray);
      setisprintplace(placeArray);
            
      fullInvoiceRefs.current = output3.map((_, i) => fullInvoiceRefs.current[i] || React.createRef());
      fullPlacesRefs.current =  output3.map((_, i) => fullPlacesRefs.current[i] || React.createRef());
      
    }
   
    fetchData();  // show new program    
    fetchData2();  // show invoice data    
         
    },[token]);

  
  const fncallback = (e,iserror) => {
    e.preventDefault(); 
    if(iserror === true)
    {
      modalsRef.current.fnclose();                                    
      history.push('/login');
    }
    else{
      modalsRef.current.fnclose();        
      //modalsRef.current.fnshow('Output','กรุณากรอกข้อมูลก่อนครับ',false,false,"1");                             
    }
    
  }

  const calculateMod10CheckDigit = (barcode) => {
    // for print barcode cardid
    barcode = barcode.trim();
    const barcodeLength = barcode.length;
  
    let sumOdd = 0;
    for (let i = 0; i < barcodeLength; i += 2) {
      sumOdd += parseInt(barcode[i], 10);
    }
  
    const sumOddTimesThree = sumOdd * 3;
  
    let sumEven = 0;
    for (let i = 1; i < barcodeLength; i += 2) {
      sumEven += parseInt(barcode[i], 10);
    }
  
    const totalSum = sumOddTimesThree + sumEven;
    const lastDigit = totalSum % 10;
  
    return lastDigit === 0 ? 0 : 10 - lastDigit;
  };

  const getFormattedDate = () => {   
    return format(new Date(), 'yyyy-MM-dd'); // Get the current date in 'YYYY-MM-DD' format
  };
  
    const handleprintinvoice  = async (e,row) =>{
      //1234567890121  //gnuserid or cardid
      //tidtid
      e.preventDefault(); 
      // Find the index of the row
      const rowIndex = data2.findIndex(item => item === row);
      console.log('Row Index:', rowIndex);
      console.log(data2);
      
      let myoutput = calculateMod10CheckDigit(data2[rowIndex].ref1); // for print barcode
      let myoutput2 = data2[rowIndex].ref1 + myoutput.toString();
      console.log(myoutput2);

       
      const currentDate = parseISO(getFormattedDate()); // Parse the formatted string into a Date object
      const targetDate = parseISO(data2[rowIndex].enddate); // Parse the target date into a Date object
      
      console.log('currentDate',currentDate);
      console.log('targetDate',targetDate);
      
      if (isAfter(currentDate, targetDate)) {
        alert("don't have invoice button");
      }
      else{
        alert("have invoice button");
      }
   
      
    }

     
    const fntest = async (e) => {
      // save in edit template form
      e.preventDefault(); 

      console.log(QEdittemplate);    
          
      const response = await Axios.post('/edittargetprogram', QEdittemplate, {               
        'withCredentials': false,     
        headers:{
            "x-access-token": token,              
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',        
      }});
      let output = response.data; 
            
      if(output[0].issuccess === 1){
        //alert(`${output[0].msg}`);  
        modalsRef.current.fnshow('Output',`${output[0].msg}`,false,false,"1");         
        
        settoken((a) => (output[0].token));
        
        handleClose();                       
        
      }
      else{
        alert(`${output[0].msg}`);
      }


      
    }
    const handleonQEdit  = async (e,row) =>{  
      e.preventDefault();
      // Find the index of the row
      const rowIndex = data2.findIndex(item => item === row);
      console.log('Row Index:', rowIndex);       
      //data2[rowIndex].ref1
      
      setQEdittemplate((p) => ({...p
        ,lang:gclang
        ,ID_Number:data2[rowIndex].ID_Number
        ,CUBEST:data2[rowIndex].CUBEST
        ,LeadName:data2[rowIndex].LeadName
        ,First_Name_Thai:data2[rowIndex].First_Name_Thai
        ,Last_Name_Thai:data2[rowIndex].Last_Name_Thai
        ,First_Name_Eng:data2[rowIndex].First_Name_Eng
        ,Last_Name_Eng:data2[rowIndex].Last_Name_Eng
        ,Birth_Date:data2[rowIndex].Birth_Date
        ,Sex:data2[rowIndex].Sex
        ,ID_Issue_Place:data2[rowIndex].ID_Issue_Place
        ,ID_Expiry_Date:data2[rowIndex].ID_Expiry_Date
        ,Email:data2[rowIndex].Email
        ,Address1:data2[rowIndex].Address1
        ,Telephone:data2[rowIndex].telephone
        ,MobilePhone:data2[rowIndex].mobilephone
        ,Target_Program:data2[rowIndex].Target_Program,}));     
            
      handleShow();
    
    }

    const HandlerApply = async (e,ref,test_language,Program) =>{    
      //1234567890121      
      e.preventDefault(); 
      let myjsondata = {};
      
      myjsondata.Program =Program;
      myjsondata.CUBEST = ref;
      myjsondata.Test_language = test_language;
      myjsondata.ID_Number = gnuserid;
      console.log('Apply Program ja',myjsondata);
      
        
      const response = await Axios.post('/applyprogram', myjsondata,{               
        'withCredentials': false,     
        headers:{
            "x-access-token": token,              
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0',        
      }});
      let output = response.data; 
      //console.log(output);
      
      if(output[0].issuccess === 1){
        //alert(`${output[0].msg}`);  
        modalsRef.current.fnshow('Output',`${output[0].msg}`,false,false,"1");         
        settoken((a) => (output[0].token));
        
      }
      else{
        alert(`${output[0].msg}`);
      }
   
      
    }
   

    const columns = [
      {
        name: 'โปรแกรม',
        selector: row => row.program,
        sortable: true,
        
      },
      {
          name: 'ครั้งที่',
          selector: row => row.ref,
          sortable: true,
          
      },
      {
        name: 'วันที่สอบ',
        selector: row => row.testdate,
        sortable: true,
        
      },
      {
      name: 'เริ่มสมัครวันที่',
      selector: row => row.startdate,
      sortable: true,
      
      },
      {
        name: 'ปิดรับสมัครวันที่',
        selector: row => row.enddate,
        sortable: true,
        
      },

      {
        name: 'วันที่คะแนนหมด',
        selector: row => row.expiry_date,
        sortable: true,        
      },
       
      {
        name: "Actions",                    
        cell:(row)=><button onClick={(e) => HandlerApply(e,row.ref,row.test_language,row.program)}>สมัคร</button>,                
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      }
  ];

  
  const columns2 = [
    
    {
      name: 'โปรแกรม',
      selector: row => row.Program,
      sortable: true,
      
    },
    {
        name: 'ครั้งที่',
        selector: row => row.CUBEST,
        sortable: true,
        
    },
    {
      name: 'สถานะของใบสมัคร',
      selector: row => row.StatusDescription,
      sortable: true,
      
    },
    {
      name: 'วันที่สอบ',
      selector: row => row.testdate,
      sortable: true,
      
    },
    {
    name: 'เริ่มสมัครวันที่',
    selector: row => row.startdate,
    sortable: true,
    
    },
    {
      name: 'ปิดรับสมัครวันที่',
      selector: row => row.enddate,
      sortable: true,
      
    },

    {
      name: 'วันที่คะแนนหมด',
      selector: row => row.expiry_date,
      sortable: true,        
    }, 
  
    {
      name: "Actions",
      cell: (row, index) => {                
        return (            
          <span>
            &nbsp;&nbsp;
            <ReactToPrint
              trigger={() => (
                <button disabled={!isprintinvoice[index]}>พิมพ์ใบแจ้งชำระหนี้</button>
              )}
              content={() => fullInvoiceRefs.current[index].current}
            />&nbsp;&nbsp;
            <ReactToPrint
              trigger={() => (
                <button disabled={!isprintplace[index]}>พิมพ์สถานที่สอบ</button>
              )}
              content={() => fullPlacesRefs.current[index].current}
            />&nbsp;&nbsp;
            <button onClick={(e) => handleonQEdit(e,row)}>แก้ไข/แสดง ใบสมัครของท่าน</button>&nbsp;&nbsp;
            {/* Hidden Component for Printing */}
            <div style={{ display: 'none' }}>
              <FullInvoice ref={fullInvoiceRefs.current[index]} invoice={row} />
            </div>
            <div style={{ display: 'none' }}>
              <FullPlaces ref={fullPlacesRefs.current[index]} invoice={row} />
            </div>
          </span>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }



  ];

  const customStyles = {
      headRow: {
        style: {
          border: 'none',
        },
      },
      headCells: {
        style: {
          fontSize: '14px',
          fontWeight: '600',
          textTransform: 'uppercase',        
          color: '#202124',        
        },
      },
      rows: {
        highlightOnHoverStyle: {
          backgroundColor: 'rgb(230, 244, 244)',
          borderBottomColor: '#FFFFFF',
          borderRadius: '25px',
          outline: '1px solid #FFFFFF',
        },
      },
      pagination: {
        style: {
          border: 'none',
        },
      },
    };
  
  function search(rows){
    const columns = rows[0] && Object.keys(rows[0]); // เอา ทุก columns
            
    return rows.filter( (row) =>         
      
      // ค้นหา แบบ ทุก columns
      //columns.some((column) => row[column].toString().toLowerCase().indexOf(q.toLowerCase()) > -1)  
      
      // ค้นหา แบบ กำหนดว่าจะเอา Column ไหนบ้าง
      searchcolumns.some((column) => row[column].toString().toLowerCase().indexOf(q.toLowerCase()) > -1)
      
      // ค้นหา แบบ Manual
      //row.title.toLowerCase().indexOf(q.toLowerCase()) > -1 ||
      //row.year.toLowerCase().indexOf(q) > -1 
    
    );
  }

  function search2(rows){                
    return rows.filter( (row) =>                                
      searchcolumns2.some((column) => row[column].toString().toLowerCase().indexOf(q.toLowerCase()) > -1)              
    );
  }
  


  return (    
    <>
        <Modal  
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                fullscreen={true}
        > 

        <Modal.Header>        
          <Modal.Title>แบบฟอร์มแก้ไขใบสมัครของท่าน</Modal.Title>        
        </Modal.Header>
              
        <Modal.Body>
       
          <FrmQEditProfile QEdittemplate={QEdittemplate} setQEdittemplate={setQEdittemplate} /> 
        
        </Modal.Body>
        <Modal.Footer>
        <Button variant="success" onClick={fntest}>Save</Button>        
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          
        </Modal.Footer>
      </Modal> 

      <Modals_Load ref={modalsRef_load} />
      <Modals lctitle='' lcbody='' fullscreen='false' fncallback={fncallback} ref={modalsRef} />
      <br></br>      
        <div className="card" style={{width: '100%;'}}>      
        <div className="card-body">
        
          <div className="row mb-3">  
            <h4><i class="fa fa-table" aria-hidden="true"></i>&nbsp;ใบสมัคร</h4>
          </div>

          <div class="mb-1 row">
            <h5>วันที่เปิดรับสมัครสอบ :</h5>
          </div>
        
          <div class="row">  
            <div class="col-sm-12 my-1">
                <div class="card">
                    <div class="card-body">  
                        <div className="row justify-content-around">
                            <div className="col-sm-12 col-item">   
                                <div class="card-text text-start">
                                กรุณาเลือกวันสอบที่ท่านต้องการ แล้วกดปุ่ม 'สมัคร' เพื่อทำการสมัคร :
                                </div> 
                            </div>
                            {/* <div className="col-sm-2 col-item">   
                                <div class="card-text text-end">
                                    <div class="d-flex flex-row">
                                        <div class="p-2">
                                            <input type="text" placeholder="ค้นหา" className="form-control" id='txt1' value={q} onChange={(e) => setq(e.target.value)}/>
                                        </div>                                                                                                                      
                                    </div>
                                </div>                            
                            </div> */}
                        </div>
                                             

                    <DataTable
                            // title="Patient Lists"
                            columns={columns}
                            //data={data}            
                            data={search(data)}
                            //defaultSortField="id"            
                            //defaultSortAsc={true}
                            onRowClicked={ (rowData) => {              
                            console.log(rowData.ref);
                            }}   
                            // selectableRows                             
                            pagination 
                            fixedHeader            
                            fixedHeaderScrollHeight="2000px"                            
                            highlightOnHover
                            pointerOnHover            
                            striped
                            responsive                     
                            customStyles={customStyles}
                            progressPending={pending}
                            paginationRowsPerPageOptions={[10,25,50,100,1000000]}
                                                
                        />
                       
                       
                    </div>
                </div>
            </div>
          </div>       
  
          <div class="mb-5 row">
            
          </div>

          <div class="mb-1 row">
            <h5>ใบสมัครของท่าน :</h5>
          </div>
        
          <div class="row">  
            <div class="col-sm-12 my-">
                <div class="card">
                    <div class="card-body">                                               

                    <DataTable
                            // title="Patient Lists"
                            columns={columns2}
                            //data={data}            
                            data={search2(data2)}
                            //defaultSortField="id"            
                            //defaultSortAsc={true}
                            onRowClicked={ (rowData) => {              
                            console.log(rowData.ref);
                            }}   
                            // selectableRows                             
                            pagination 
                            fixedHeader            
                            fixedHeaderScrollHeight="2000px"                            
                            highlightOnHover
                            pointerOnHover            
                            striped
                            responsive                     
                            customStyles={customStyles}
                            progressPending={pending2}
                            paginationRowsPerPageOptions={[10,25,50,100,1000000]}
                                                
                        />
                       
                       
                    </div>
                </div>
            </div>
          </div>   

      
        </div>
      </div>
    
    </>          

  )
}

export default FrmApplication_th